export enum PLANES {
    B100 = 1,
    B200 = 2,
    B300 = 3,
    N200 = 4,
    N400 = 5,
    N500 = 6,
    PACKN = 7,
    PMO = 8,
    B150 = 9
}